import React from 'react'
import { useDispatch } from 'react-redux'
import { FullScreen } from '../component/PageComponent/Box'
import loadable from '@loadable/component'
import { useGeneralModal } from '../contextHook/generalModal'
import { setFullScreenActive } from '../redux/common/actions'
const ConfirmModal = loadable(() => import('../component/Modals/ConfirmModal'))
const NoActionModal = loadable(() =>
  import('../component/Modals/NoActionModal'),
)

const FullScreenLayout = ({ children, handle }) => {
  const { confirmModal, noActionModal } = useGeneralModal()
  const dispatch = useDispatch()
  return (
    <FullScreen
      handle={handle}
      onChange={isFullScreen => dispatch(setFullScreenActive(isFullScreen))}
    >
      {children}
      {confirmModal && handle.active && <ConfirmModal {...confirmModal} />}
      {noActionModal && handle.active && <NoActionModal {...noActionModal} />}
    </FullScreen>
  )
}

export default FullScreenLayout
